import React, { useEffect, useContext, useState } from 'react';
//Functional Component 
import { logOut } from "../firebase/firebase";
import { signInWithGoogle } from "../firebase/firebase";
import { UserContext } from '../providers/UserProvider';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { uuid } from 'uuidv4';


export default function LoginPage(){
    //localStorage.setItem('mode','none');
    const user = useContext(UserContext);
    const [redirect, setredirect] = useState(null);
    const history = useHistory();
    var tutorMode = true;
    
    function setModeStudent(){
      console.log("User chose student mode");
      localStorage.setItem('mode','student');
      signInWithGoogle();
    }

    function setModeTutor(){
      console.log("User chose tutor mode");
      localStorage.setItem('mode','tutor');
      signInWithGoogle();

    }




    useEffect(() => {
      if (user) {
        const {displayName, email} = user;
        console.log(email);
        
        if(localStorage.getItem('mode') == 'tutor')
        {
          axios.post("https://auxilliabackend.herokuapp.com/authenticateTutor",{email:email})
          .then(function (response) {
            const data = response.data;
            const [value] = data.value;

            localStorage.setItem('email',email);
            
            console.log(value);
            console.log("SENDING ROUTE");
            if(value == "F"){
              
              history.push({pathname: '/tutorProfileSetup'});
              window.location.reload(true);
            }
            else{
              history.push({pathname: '/chats'});//change to tutor profile /////////////////////////////////////////////////////////////////////////////////////
              window.location.reload(true);
            }
  
          })
          .catch(function (error) {
            console.log(error);
          });
        }
        else if(localStorage.getItem('mode') == 'student')
        {
          axios.post("https://auxilliabackend.herokuapp.com/authenticateStudent",{email:email})
          .then(function (response) {
            const data = response.data;
            const [value] = data.value;
            console.log("STUDENT");
            console.log(value);

            localStorage.setItem('email',email);
            localStorage.setItem('sessionID',uuid());      
            if(value == "F"){
              
              history.push({pathname: '/studentProfileSetup'});
              window.location.reload(true);
            }
            else{
              history.push({pathname: '/home'});//change to student profile /////////////////////////////////////////////////////////////////////////////////////
              window.location.reload(true);
            }
  
          })
          .catch(function (error) {
            console.log(error);
          });
        }
        
      }
    }, [user])
      //when you press a button can it declare a variable as well as signInWithGoogle?

      
        return (
          <div className="App">

          <body className = "App-header">
            <div class = "loginbox">
              <img src = "logo192.png" class = "logo"></img>
              <h1>AUXILLIA</h1>
                <input type = "button" name = "" value = "Login as Tutor" onClick={() => setModeTutor()}></input>
                  {/* <p>Username</p> */}
                <input type = "button" name = "" value = "Login as Student" onClick={() => setModeStudent()}></input>
                  {/* <p>Username</p> */}

            </div>
          </body>




          {/*pull from   local storage localStorage.getItem('mode')*/}
          {/*push to   local storage localStorage.setItem('mode','student');*/}
          
{/* All this was from sean and rakhi after this point */}
            {/* <div>
              <div className="login-buttons">
                <button className="login-provider-button" onClick={signInWithGoogle}> <--- this what it was like b4
                  <img src="https://img.icons8.com/ios-filled/50/000000/google-logo.png" alt="google icon"/>
                  <span> Continue with Google</span>
                </button>
              </div>
                  
              <div className="dashboard">
                <h1 className="dashboard-text">Welcome Home</h1>

                <button className="logout-button" onClick={logOut}>
                  <img src="https://img.icons8.com/ios-filled/50/000000/google-logo.png" alt="google icon" />
                  
                  <span> logout</span>
                </button>
              </div>
            </div> */}
        
        </div>        );
    }
